import React, { Component, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import { Pagination } from "../Pagination/Pagination";
import { getMessagemErro } from "../../utils/erro";
import { baixarArquivo } from "../../utils/downloadUtil";
import api from "../../services/api";
import DatePicker, { registerLocale } from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import { PopupHistoricoTransferencia } from "./PopupHistoricoTransferencia";
import SelectSearch from "../UI/SelectSearch/SelectSearch";

registerLocale("pt_br", pt_br);

const mapDispatchToProps = { exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando };

const mapStateToProps = (state) => ({
	user: state.usuarioStore.user,
});

const formatarDataEvento = (dataEvento) => {
	if (!dataEvento) return '';
	const d = new Date(dataEvento);
	if (isNaN(d.getTime())) return '';
	const dia = String(d.getDate()).padStart(2, '0');
	const mes = String(d.getMonth() + 1).padStart(2, '0');
	const ano = d.getFullYear();
	const hora = String(d.getHours()).padStart(2, '0');
	const min = String(d.getMinutes()).padStart(2, '0');
	return `${dia}/${mes}/${ano} ${hora}:${min}`;
};

const ResultadoTransferencias = ({ resultados, resultadoPesquisa, onAbrirHistorico, onChangePage }) => {
	const [hoveredRow, setHoveredRow] = useState(null);
	if (!resultados || resultados.length === 0) return null;
	const paginaAtual = resultadoPesquisa?.number || 0;
	const tamanhoPagina = resultadoPesquisa?.size || 10;
	const inicio = paginaAtual * tamanhoPagina + 1;
	const fim = Math.min((paginaAtual + 1) * tamanhoPagina, resultadoPesquisa?.totalElements);
	return (
		<div className="br-table" style={{ marginTop: '20px' }}>
			<table>
				<thead>
					<tr>
						<th>ID</th>
						<th>Arquivo</th>
						<th>Cedente dos Dados</th>
						<th>Órgão Destino</th>
						<th>Status</th>
						<th>Data Evento</th>
						<th>Ação</th>
					</tr>
				</thead>
				<tbody>
					{resultados.map((item) => (
						<tr key={item.id}
							onMouseEnter={() => setHoveredRow(item.id)}
							onMouseLeave={() => setHoveredRow(null)}
						>
							<td>{item.id}</td>
							<td>{item.nomeArquivo}</td>
							<td>{item.nomeOrgaoOrigem || '-'}</td>
							<td>{item.nomeOrgaoDestino}</td>
							<td>{item.status}</td>
							<td>{formatarDataEvento(item.dataEvento)}</td>
							<td>
								<button 
									type="button" 
									className="button"
									onClick={() => onAbrirHistorico(item.id)}
									title="Ver detalhes"
									style={{
										backgroundColor: '#dbe8fb',
										color: '#1351b4',
										borderRadius: '50%',
										width: '36px',
										height: '36px',
										border: 'none',
										cursor: 'pointer',
										display: 'inline-flex',
										alignItems: 'center',
										justifyContent: 'center',
										boxShadow: hoveredRow === item.id ? '0 0 0 2px #1351b4' : 'none',
									}}
								>
									<i className="fas fa-eye"></i>
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
			<div style={{ marginTop: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
				<p style={{ margin: 0 }}>Exibindo {inicio} a {fim} de {resultadoPesquisa?.totalElements} registro(s)</p>
			</div>
			{resultadoPesquisa?.totalPages > 1 && (
				<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={onChangePage} />
			)}
		</div>
	);
};

export const RelatorioTransferencias = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(
		class extends Component {

			constructor(props) {
				super(props);
				const hoje = new Date();
				const mesPassado = new Date();
				mesPassado.setMonth(mesPassado.getMonth() - 1);
				this.state = {
					dataInicio: mesPassado,
					dataFim: hoje,
					nomeArquivo: '',
					idOrgaoOrigem: '',
					orgaosOrigem: [],
					botoesHabilitados: true,
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				registrosPorPagina: 10,
				popupAberto: false,
				idTransferenciaPopup: null,
			};
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
				this.baixarRelatorio = this.baixarRelatorio.bind(this);
				this.limpar = this.limpar.bind(this);
				this.handleInputChange = this.handleInputChange.bind(this);
				this.validaFormulario = this.validaFormulario.bind(this);
				this.abrirHistorico = this.abrirHistorico.bind(this);
				this.fecharHistorico = this.fecharHistorico.bind(this);
			}

			componentDidMount() {
				this.props.limpaMensagem();
				
				// Buscar lista de órgãos fornecedores
				api.get('/api/orgao/fornecedores-arquivo-gv')
					.then((response) => {
						if (response.data && Array.isArray(response.data)) {
							this.setState({ orgaosOrigem: response.data });
						}
					})
					.catch((erro) => {
						console.error("Erro ao buscar órgãos fornecedores:", erro);
						// Falha silenciosa - dropdown vazio é aceitável
					});
			}

			handleInputChange(evento) {
				const target = evento.target;
				this.setState({ [target.name]: target.value });
			}

			validaFormulario() {
				const { dataInicio, dataFim } = this.state;
				const mensagens = [];

				if (!dataInicio || !dataFim) {
					mensagens.push({ mensagem: "Data início e data fim são obrigatórias." });
				}

				if (dataInicio && dataFim && dataInicio > dataFim) {
					mensagens.push({ mensagem: "A data início deve ser menor ou igual à data fim." });
				}

				if (mensagens.length > 0) {
					this.props.exibeMensagemErro(
						"Não foi possível realizar a operação porque há inconsistências nos campos informados:",
						mensagens
					);
					throw new Error("Formulário inválido.");
				}
			}

			formatarDataParaISO(data, fimDoDia = false) {
				if (!data) return '';
				const ano = data.getFullYear();
				const mes = String(data.getMonth() + 1).padStart(2, '0');
				const dia = String(data.getDate()).padStart(2, '0');
				const hora = fimDoDia ? '23' : '00';
				const minuto = fimDoDia ? '59' : '00';
				const segundo = fimDoDia ? '59' : '00';
				return `${ano}-${mes}-${dia}T${hora}:${minuto}:${segundo}`;
			}

			formatarData(data) {
				if (!data) return '';
				const dia = String(data.getDate()).padStart(2, '0');
				const mes = String(data.getMonth() + 1).padStart(2, '0');
				const ano = data.getFullYear();
				return `${dia}/${mes}/${ano}`;
			}

			pesquisar() {
				try {
					this.validaFormulario();
				} catch (e) {
					return;
				}

				this.executaPesquisaPaginada(0);
			}

			executaPesquisaPaginada(pagina) {
				const { dataInicio, dataFim, nomeArquivo, idOrgaoOrigem, registrosPorPagina } = this.state;
				const params = {
					dataInicio: this.formatarDataParaISO(dataInicio),
					dataFim: this.formatarDataParaISO(dataFim, true),
				pagina: pagina,
					size: registrosPorPagina,
				};
				if (nomeArquivo && nomeArquivo.trim()) {
					params.nomeArquivo = nomeArquivo.trim();
				}
				if (idOrgaoOrigem) {
					params.idOrgaoOrigem = idOrgaoOrigem;
				}

				this.props.mostraAguardando();
				this.setState({ botoesHabilitados: false, resultadoPesquisa: {}, pesquisaExecutada: false });

				api.post('/api/transferencia-arquivo-grandes-volumes/paginado-com-filtros', null, { params })
					.then((response) => {
						this.setState({ resultadoPesquisa: response.data, pesquisaExecutada: true });
					})
					.catch((erro) => {
						const msg = getMessagemErro("Não foi possível pesquisar transferências", erro);
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					})
					.then(() => {
						this.props.escondeAguardando();
						this.setState({ botoesHabilitados: true });
					});
			}

			onChangePage = (pagina) => {
				this.executaPesquisaPaginada(pagina);
			}

			baixarRelatorio(tipo) {
				const { dataInicio, dataFim, nomeArquivo, idOrgaoOrigem } = this.state;
				const params = {
					dataInicio: this.formatarData(dataInicio),
					dataFim: this.formatarData(dataFim),
					formato: tipo,
				};
				if (nomeArquivo && nomeArquivo.trim()) {
					params.nomeArquivo = nomeArquivo.trim();
				}
				if (idOrgaoOrigem) {
					params.idOrgaoOrigem = idOrgaoOrigem;
				}

				this.props.mostraAguardando();
				this.setState({ botoesHabilitados: false });

				api({ method: 'get', url: '/api/relatorios/transferencia-gv/transferencias/download', params, responseType: 'arraybuffer' })
					.then((response) => {
						baixarArquivo(new Blob([response.data]), `RelatorioTransferenciasGV.${tipo}`);
					})
					.catch((response) => {
						try {
							const data = response.data;
							if (data && data.byteLength > 0) {
								const erro = { data: JSON.parse(Buffer.from(data).toString('utf8')) };
								const msg = getMessagemErro("Não foi possível gerar o relatório", erro);
								this.props.exibeMensagemErro(msg.mensagem, msg.erros);
							} else {
								this.props.exibeMensagemErro("Não foi possível gerar o relatório", []);
							}
						} catch (e) {
							this.props.exibeMensagemErro("Não foi possível gerar o relatório", []);
						}
					})
					.then(() => {
						this.props.escondeAguardando();
						this.setState({ botoesHabilitados: true });
					});
			}

			abrirHistorico(idTransferencia) {
				this.setState({ popupAberto: true, idTransferenciaPopup: idTransferencia });
			}

			fecharHistorico() {
				this.setState({ popupAberto: false, idTransferenciaPopup: null });
			}

			limpar() {
				this.props.limpaMensagem();
				this.setState({
					dataInicio: null,
					dataFim: null,
					nomeArquivo: '',
					idOrgaoOrigem: '',
					resultadoPesquisa: {},
					pesquisaExecutada: false,
				});
			}

			render() {
				const { dataInicio, dataFim, nomeArquivo, idOrgaoOrigem, orgaosOrigem, botoesHabilitados, resultadoPesquisa, pesquisaExecutada, popupAberto, idTransferenciaPopup } = this.state;
				const resultados = resultadoPesquisa?.content || [];
				const botaoPesquisarHabilitado = botoesHabilitados && !!dataInicio && !!dataFim;
				const exibeBotoesDownload = pesquisaExecutada && resultados && resultados.length > 0;

				return (
					<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						{popupAberto && <PopupHistoricoTransferencia idTransferencia={idTransferenciaPopup} onClose={this.fecharHistorico} />}
						<div style={{ margin: "10px" }}>
							<h1>Relatório de Transferências de Grandes Volumes</h1>
						</div>
						<div className="div-form">
							<div className="br-form">

								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Data Início: <span className="obrigatorio">*</span></label>
												<DatePicker
													locale="pt_br"
													dateFormat="dd/MM/yyyy"
													selected={dataInicio}
													onChange={(data) => this.setState({ dataInicio: data })}
												/>
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Data Fim: <span className="obrigatorio">*</span></label>
												<DatePicker
													locale="pt_br"
													dateFormat="dd/MM/yyyy"
													selected={dataFim}
													onChange={(data) => this.setState({ dataFim: data })}
												/>
											</div>
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Nome do Arquivo (Opcional):</label>
												<input
													type="text"
													name="nomeArquivo"
													value={nomeArquivo}
													onChange={this.handleInputChange}
													placeholder="Ex: SIAFI_*"
												/>
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="idOrgaoOrigem">Cedente dos Dados (Opcional):</label>
												<SelectSearch
													id="idOrgaoOrigem"
													name="idOrgaoOrigem"
													options={orgaosOrigem.map((org) => ({ value: org.id, label: org.nome }))}
													includeAllOption={true}
													onChange={this.handleInputChange}
													value={idOrgaoOrigem}
												/>
											</div>
										</div>
									</div>
								</div>

								<div className="actions-button">
									<div className="actions justify-content-start">
										<button
											type="button"
											className="button is-primary"
											onClick={this.pesquisar}
											disabled={!botaoPesquisarHabilitado}
										>
											Pesquisar
										</button>
										{exibeBotoesDownload && (
											<button type="button" className="button is-secondary" onClick={() => this.baixarRelatorio('pdf')} disabled={!botoesHabilitados}>
												Relatório PDF
											</button>
										)}
										{exibeBotoesDownload && (
											<button type="button" className="button is-secondary" onClick={() => this.baixarRelatorio('csv')} disabled={!botoesHabilitados}>
												Relatório CSV
											</button>
										)}
										<button
											type="button"
											className="button is-secondary"
											onClick={this.limpar}
											disabled={!botoesHabilitados}
										>
											Limpar
										</button>
										<ButtonBack disabled={!botoesHabilitados} />
									</div>
								</div>

								{pesquisaExecutada && resultados && resultados.length === 0 && (
									<p style={{ marginTop: '16px' }}>Nenhum registro encontrado para os filtros informados.</p>
								)}
								<ResultadoTransferencias resultados={resultados} resultadoPesquisa={resultadoPesquisa} onAbrirHistorico={this.abrirHistorico} onChangePage={this.executaPesquisaPaginada} />

							</div>
						</div>
					</main>
				);
			}
		}
	)
);
